function cartDrawerRecommendation() {
    const slider = document.querySelector('.drawer__product_slider'); // container that scrolls
    const slides = document.querySelectorAll('.drawer__recommendation-slide');
    const nextBtn = document.querySelector('.nav-btn.next');
    const prevBtn = document.querySelector('.nav-btn.prev');
    const dots = document.querySelectorAll('.dr-slide-nav-dot');

    if (!document.documentElement.dataset.cdrSliderDelegatedInitialized) {
        document.documentElement.dataset.cdrSliderDelegatedInitialized = 'true';
        document.addEventListener('click', (event) => {
            const next = event.target && event.target.closest ? event.target.closest('.nav-btn.next') : null;
            const prev = event.target && event.target.closest ? event.target.closest('.nav-btn.prev') : null;
            const dot = event.target && event.target.closest ? event.target.closest('.dr-slide-nav-dot') : null;
            if (!next && !prev && !dot) return;

            const activeSlider = document.querySelector('.drawer__product_slider');
            const activeSlides = document.querySelectorAll('.drawer__recommendation-slide');
            const activeDots = document.querySelectorAll('.dr-slide-nav-dot');
            if (!activeSlider || activeSlides.length === 0) return;

            const current = parseInt(activeSlider.dataset.cdrCurrentSlide || '0', 10) || 0;

            let targetIndex = current;
            if (next) targetIndex = current + 1;
            if (prev) targetIndex = current - 1;

            if (dot) {
                targetIndex = Array.prototype.indexOf.call(activeDots, dot);
                if (targetIndex < 0) return;
            }

            if (targetIndex >= activeSlides.length) targetIndex = 0;
            if (targetIndex < 0) targetIndex = activeSlides.length - 1;

            activeSlider.dataset.cdrCurrentSlide = String(targetIndex);

            const slideWidth = activeSlides[0].offsetWidth;
            activeSlider.scrollTo({
                left: slideWidth * targetIndex,
                behavior: 'smooth'
            });

            activeDots.forEach(d => d.classList.remove('active'));
            if (activeDots[targetIndex]) activeDots[targetIndex].classList.add('active');
        });
    }

    const drawerCart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");

    if (!document.documentElement.dataset.cdrAjaxAddInitialized) {
        document.documentElement.dataset.cdrAjaxAddInitialized = 'true';
        document.addEventListener('click', (event) => {
            const button = event.target && event.target.closest ? event.target.closest('.dr-slide-add-cta') : null;
            if (!button) return;

            event.preventDefault();

            const productId = parseInt(button.getAttribute('data-product-id'), 10);
            const variantId = parseInt(button.getAttribute('data-id'), 10);

            if (!Number.isFinite(productId) || !Number.isFinite(variantId)) return;

            const activeDrawerCart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");

            const config = fetchConfig("javascript");
            config.headers["X-Requested-With"] = "XMLHttpRequest";
            delete config.headers["Content-Type"];

            const formData = new FormData();
            formData.append('form_type', 'product');
            formData.append('utf8', '✓');
            formData.append('product-id', productId);
            formData.append('id', variantId);

            if (activeDrawerCart) {
                formData.append(
                    "sections",
                    activeDrawerCart.getSectionsToRender().map((section) => section.id)
                );
                formData.append("sections_url", window.location.pathname);
                activeDrawerCart.setActiveElement(document.activeElement);
            }
            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (!activeDrawerCart) {
                        window.location = window.routes.cart_url;
                        return;
                    }
                    activeDrawerCart.renderContents(response);
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    console.log("Product Added");
                });
        });
    }
};

document.addEventListener("DOMContentLoaded", cartDrawerRecommendation);
subscribe(PUB_SUB_EVENTS.cartUpdate, cartDrawerRecommendation);
